import React, {Component} from 'react';
import Link from 'components/Link';

import {APP_CONFIG} from 'Config';

class AuctionTile extends Component {
    state = {
        isExpired: false,
        validExpiredTime: true,
    };

    renderPhone = () => {
        const { facility: { phone = '' } = {} } = this.props.auction;

        const phone_link = `tel://${phone.replace(/\D/g, '')}`;

        // return !phone || !APP_CONFIG.VALIDATION.API_FORMAT_PHONE.test(phone) ? null : (
        return !phone ? null : (
          <div className="phone">
            <a href={phone_link}>
                <i className="fa fa-phone-alt"/>
              {' '}
              {phone}
            </a>
          </div>
        );
    };

    renderUnitCount = () => {
        const { unit_count = 0 } = this.props.auction;

        if (isNaN(unit_count) || parseInt(unit_count) == 0) {
            return (
              <span className="body unit-count call">
                Call for
                {' '}
                <br />
                Details
              </span>
            );
        }

        return (
          <span className="body unit-count">
            {unit_count}
          </span>
        );
    };

    getAuctionTileName = () => {
        const { live_auction_id } = this.props.auction;
        const { isExpired = false, validExpiredTime = true } = this.state;
        const expired = isExpired ? ' expired' : '';
        const valid = validExpiredTime ? '' : ' invalidExpiredTime';

        return `live-auction-tile live-auction-id-${live_auction_id}${expired}${valid}`;
    };

    getLink = () => {
        const { facility_id } = this.props.auction;

        return `/facilities/${facility_id}#live-auctions`;
    };

    render() {
        const {
            facility: {
                facility_name = '',
                address = '',
                city = '',
                state = '',
                zipcode = '',
            } = {},

            expire_date: {
                user: {
                    date_formatted,
                    time_formatted,
                } = {},
            } = {},

            live_auction_id = '-1',
        } = this.props.auction;

        return (
          <div className={this.getAuctionTileName()} id={`live-auction-tile-${live_auction_id}`}>
            <div className="section facility-details">
              <div className="tile-title">
                <Link to={this.getLink()}>{facility_name}</Link>
              </div>

              <address>
                {address}
                {' '}
                <br />
                {city}
                ,
                {' '}
                  {state}
                {' '}
                {zipcode}
              </address>

              {this.renderPhone()}
              {' '}
              <br />
            </div>

            <div className="section live-auction-timer">
              <div className="date">
                <span className="title">Date/Time:</span>
                <span className="body">
                  {date_formatted}
                  {' '}
                  <br />
                  {time_formatted}
                </span>
              </div>
              <div className="count">
                <span className="title"># of Units:</span>
                {this.renderUnitCount()}
              </div>
            </div>
          </div>
        );
    }
}

AuctionTile.defaults = {
    auction: {},
};

export default AuctionTile;
